/**
 * Copyright © 2024-2026 Entangled Harmony Labs, LLC
 * All Rights Reserved. Proprietary and Confidential.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import './App.css';
import App from './App';
import AboutPage from './pages/AboutPage';
import CreatorsPage from './pages/CreatorsPage';
import { ChatProvider } from './context/ChatContext';
import { ActivityLoggerProvider } from './context/ActivityLoggerContext';
import { SkillLevelProvider } from './context/SkillLevelContext';
import { ClerkProvider } from '@clerk/clerk-react';

const clerkPubKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPubKey) {
  throw new Error('Missing Clerk Publishable Key. Please add REACT_APP_CLERK_PUBLISHABLE_KEY to your .env file.');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProvider publishableKey={clerkPubKey}>
        <SkillLevelProvider>
          <ActivityLoggerProvider>
            <ChatProvider>
              <Routes>
              <Route path="/" element={<App />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/creators" element={<CreatorsPage />} />
              </Routes>
            </ChatProvider>
          </ActivityLoggerProvider>
        </SkillLevelProvider>
      </ClerkProvider>
    </BrowserRouter>
  </React.StrictMode>
);
